/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'fabric.elements.share.copied.to.clipboard.message': 'Link copiado para a área de transferência',
  'fabric.elements.share.copylink.button.text': 'Copiar link',
  'fabric.elements.share.copypubliclink.button.text': 'Copiar link público',
  'fabric.elements.share.failure.icon.label': 'Ícone de erro',
  'fabric.elements.share.failure.message': 'Não foi possível compartilhar',
  'fabric.elements.share.form.comment.label': 'Mensagem (opcional)',
  'fabric.elements.share.form.comment.placeholder': 'Há algo que eles deveriam saber?',
  'fabric.elements.share.form.info.message.no.invite.confluence':
    'Os destinatários vão ver o nome da página e sua mensagem',
  'fabric.elements.share.form.info.message.no.invite.jira': 'Os destinatários vão ver o nome do item e sua mensagem',
  'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh':
    'Os destinatários vão ver o nome do ticket e a mensagem',
  'fabric.elements.share.form.no-permissions': 'Você não está apto a compartilhar.',
  'fabric.elements.share.form.public.send': 'Enviar link público',
  'fabric.elements.share.form.public.share': 'Compartilhar link público',
  'fabric.elements.share.form.required-field.summary': 'Os campos obrigatórios estão marcados com um asterisco',
  'fabric.elements.share.form.retry': 'Tentar novamente',
  'fabric.elements.share.form.send': 'Enviar',
  'fabric.elements.share.form.share': 'Compartilhar',
  'fabric.elements.share.form.title': 'Compartilhar',
  'fabric.elements.share.form.user-picker.add-more': 'Insira mais itens',
  'fabric.elements.share.form.user-picker.label.confluence': 'Nomes, equipes, grupos ou e-mails',
  'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomes, equipes ou grupos',
  'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomes ou equipes',
  'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
  'fabric.elements.share.form.user-picker.label.jira': 'Nomes, equipes ou e-mails',
  'fabric.elements.share.form.user-picker.no-options.existingUserOnly':
    'Não encontramos nenhum resultado para "{inputValue}".',
  'fabric.elements.share.form.user-picker.no-options.generic':
    'Não encontramos nenhum resultado para "{inputValue}". Convide pessoas usando um endereço de e-mail.',
  'fabric.elements.share.form.user-picker.placeholder.confluence': 'por exemplo, Maria, equipe laranja, grupo um',
  'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'por exemplo, Maria, equipe laranja',
  'fabric.elements.share.form.user-picker.placeholder.email-only': 'por exemplo, maria@empresa.com',
  'fabric.elements.share.form.user-picker.placeholder.jira': 'por exemplo, Maria, equipe laranja, maria@empresa.com',
  'fabric.elements.share.form.user-picker.validation.required':
    'Selecione ao menos um usuário, grupo, equipe ou e-mail.',
  'fabric.elements.share.form.user-picker.validation.required-message.confluence':
    'Selecione pelo menos uma pessoa, equipe, grupo ou e-mail',
  'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence':
    'Selecione pelo menos uma pessoa, equipe ou grupo',
  'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira':
    'Selecione pelo menos uma pessoa ou equipe',
  'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Selecione pelo menos um e-mail',
  'fabric.elements.share.form.user-picker.validation.required-message.jira':
    'Selecione pelo menos uma pessoa, equipe ou e-mail',
  'fabric.elements.share.in.integration.button': 'Compartilhar em {integrationName}',
  'fabric.elements.share.invite.to.confluence': 'Convidar para o Confluence',
  'fabric.elements.share.invite.to.jira': 'Convidar para o Jira',
  'fabric.elements.share.main.tab.text.confluence': 'Compartilhar página',
  'fabric.elements.share.main.tab.text.jira': 'Compartilhar item',
  'fabric.elements.share.menu.email.label': 'E-mail',
  'fabric.elements.share.menu.slack.label': 'Slack',
  'fabric.elements.share.popup.label': 'Compartilhar',
  'fabric.elements.share.success.message':
    '{object, select,blogpost {Blog compartilhado}board {Quadro compartilhado}calendar {Calendário compartilhado}draft {Rascunho compartilhado}filter {Filtro compartilhado}issue {Item compartilhado}summary {Resumo compartilhado}list {Lista compartilhada}timeline {Cronograma compartilhado}form {Formulário compartilhado}media {Mídia compartilhada}page {Página compartilhada}project {Projeto compartilhado}pullrequest {Pull request compartilhada}question {Pergunta compartilhada}report {Relatório compartilhado}repository {Repositório compartilhado}request {Solicitação compartilhada}roadmap {Cronograma compartilhado}site {Site compartilhado}space {Espaço compartilhado}other {Link compartilhado}}',
  'fabric.elements.share.to.integration.button': 'Compartilhar em {integrationName}',
  'fabric.elements.share.trigger.button.icon.label': 'Ícone de compartilhamento',
  'fabric.elements.share.trigger.button.invite.text': 'Convidar',
  'fabric.elements.share.trigger.button.text': 'Compartilhar',
  'fabric.elements.share.trigger.button.tooltip.text': 'Compartilhar',
};
